window.theme = window.theme || {};
// money format
theme.formatMoney = function (cents, format) {
  // theme.formatMoney(10000,theme.money_format)
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
// image lazy loading
if(!customElements.get('lazy-image')){
  class lazyLoad extends HTMLElement {
    constructor() {
      super();
      this.lazyLoadFn();
    }
    lazyLoadFn = () => {
      const img = this.querySelector('img');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let image = entry.target;
            setTimeout(() => {
              let imageHeight = image.clientHeight;
              if (imageHeight == 0) {
                imageHeight = 100
              }
              let imageWidth = image.clientWidth;
              if (imageWidth == 0) {
                imageWidth = 100
              }
              if (image.src.indexOf('width') > 0 || image.src.indexOf('height') > 0) {
                let baseImgUrl = image.src.replace(/&width=[0-9]/, '').replace(/&height=[0-9]/, '');
                if (imageHeight >= imageWidth) {
                  image.src = `${baseImgUrl}&height=${imageHeight}`;
                } else {
                  image.src = `${baseImgUrl}&width=${imageWidth}`;
                }
              } else {
                if (imageHeight >= imageWidth) {
                  image.src = `${image.src}&height=${imageHeight}`;
                } else {
                  image.src = `${image.src}&width=${imageWidth}`;
                }
              }
            }, 500);
            image.classList.add('img-loaded');
            io.unobserve(image);
          }
        })
      });
      if (img) {
        io.observe(img);
      }
      if (Shopify.designMode) {
        const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];
        customizationEvents.forEach(event => {
          document.addEventListener(event, () => io.observe(img));
        })
      }
    }
  }
  customElements.define('lazy-image', lazyLoad);
}

// custom dropdown
if (!customElements.get('drop-down')){
  class dropDown extends HTMLElement {
    constructor() {
      super()
      this.onclick();
      this.onSelect();
    }
    onclick = () => {
      let btn = this.querySelector('.el-dropdown-button'),
        list = this.querySelector('.el-dropdown-list');
      btn.addEventListener('click', () => {
        list.classList.toggle('active');
        btn.classList.toggle('active');
        btn.focus();
      })
  
      // close when click outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          list.classList.remove('active');
          btn.classList.remove('active');
        }
      })
    }
    onSelect = () => {
      let inputField = this.querySelector('input[type="hidden"]'),
        listItem = this.querySelectorAll('.el-dropdown-list-item a'),
        btn = this.querySelector('.el-dropdown-button'),
        list = this.querySelector('.el-dropdown-list');
      listItem.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          listItem.forEach(link => link.classList.remove('active'))
          link.classList.add('active');
          inputField.value = link.dataset.value;
          btn.querySelector('span').textContent = link.textContent;
          list.classList.remove('active');
          btn.classList.remove('active');
        })
      })
    }
  }
  customElements.define('drop-down', dropDown);
}

// close collection filters modal
window.theme.closeFilter = () => {
  let filterBtn = document.querySelector('.utility-bar__left .utility-bar__item');
  let filterClose = document.querySelectorAll('.filter-modal-overlay,.mobile-header .button-icon');
  if (filterBtn) {
    filterBtn.addEventListener('click', () => {
      document.querySelector('.utility-bar__left .utility-bar__item').classList.toggle('active');
      document.querySelector('.facets-container').classList.toggle('active')
      document.body.classList.toggle('facets-container-active');
    })
  }
  if (filterClose.length > 0) {
    filterClose.forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelector('.utility-bar__left .utility-bar__item').classList.remove('active');
        document.querySelector('.facets-container').classList.remove('active');
        document.body.classList.remove('facets-container-active');
      })
    });
  }
}

// glogal quantity picker used in cart and product page
if (!customElements.get('quantity-picker')) {
  class quantityPicker extends HTMLElement {
    constructor() {
      super();
      this.incBtn = this.querySelector('.qnt-inc');
      this.decBtn = this.querySelector('.qnt-dec');
      this.inputField = this.querySelector('input[type="number"]');
      this.onIncrease();
      this.onDecrease();
    }
    onIncrease = () => {
      this.incBtn.addEventListener('click', (e) => {
        this.inputField.value = parseInt(this.inputField.value) + 1;
        this.inputField.dispatchEvent(new Event('change'));
      })
    }
    onDecrease = () => {
      this.decBtn.addEventListener('click', (e) => {
        parseInt(this.inputField.value) <= 1 ? this.inputField.value = 1 : this.inputField.value = parseInt(this.inputField.value) - 1;
        this.inputField.dispatchEvent(new Event('change'));
      })
    }
  }
  customElements.define('quantity-picker',quantityPicker);
}
// theme.quantityPicker = () => {
//   let qntPickerEle = document.querySelectorAll('.qnt-input-wrapper');
//   if (qntPickerEle.length > 0) {
//     qntPickerEle.forEach(qnt => {
//       let qntDec = qnt.querySelector('.qnt-dec'),
//         qntInc = qnt.querySelector('.qnt-inc');
//       qntDec.addEventListener('click', (e) => {
//         let that = e.currentTarget;
//         let qntInput = that.parentNode.querySelector('input[name="quantity"]');
//         let qntVal = parseInt(qntInput.value);
//         if (e.currentTarget.closest('.cart-items')) {
//           qntInput.value = qntVal - 1;
//         } else {
//           qntVal <= 1 ? qntInput.value = 1 : qntInput.value = qntVal - 1;
//         }
//         qntInput.dispatchEvent(new Event('change'));
//       })
//       qntInc.addEventListener('click', (e) => {
//         let that = e.currentTarget;
//         let qntInput = that.parentNode.querySelector('input[name="quantity"]')
//         let qntVal = parseInt(qntInput.value);
//         qntInput.value = qntVal + 1;
//         qntInput.dispatchEvent(new Event('change'));
//       })
//     })
//   }
// }

// Back to Top scroll
theme.backtoTop = () => {
  const backToTopButton = document.querySelector(".back-to-top-btn");
  if(backToTopButton){
    backToTopButton.onclick = () =>
      document.documentElement.scroll({
        top: 0,
        behavior: "smooth"
      });
    window.onscroll = () => {

      if (document.documentElement.scrollTop > 60) {
        backToTopButton.classList.remove("hidden");
      } else {
        backToTopButton.classList.add("hidden");
      }
    };
  }
}

// Infinite scroll
theme.infiniteScroll = () => {
  let cacheCount = 0;
    let productEle = document.querySelector('[data-next-page]');
    if(productEle){
      const intersectionObserver = new IntersectionObserver(function (entries){
        if(entries[0].isIntersecting){
          let infiniteProductEle = document.querySelector('[data-next-page]');
          let url = infiniteProductEle.dataset.nextPage;
          if(url != ""){
            cacheCount++;
          }
          if (url != "") {
            fetch(url)
            .then(res => res.text())
            .then(data => {                
                cacheCount = 0;
                var dataHTML = new DOMParser().parseFromString(data, 'text/html');
                let productGrid = dataHTML.querySelector('[data-next-page]').innerHTML;
                infiniteProductEle.insertAdjacentHTML("beforeend",productGrid);
                infiniteProductEle.dataset.nextPage = dataHTML.querySelector('[data-next-page]').dataset.nextPage;
                if(document.querySelector('[data-next-page]').dataset.nextPage != ""){
                  document.querySelector('.pagination-loader').style.display = null;
                } else {
                  document.querySelector('.pagination-loader').style.display = "none";
                }
                // animation function
                theme.onScrollAnimation();
            })
          } 
          else {
            document.querySelector('.pagination-loader').style.display = "none";
            intersectionObserver.disconnect();
          }
        }
      });
      intersectionObserver.observe(document.querySelector(".pagination-loader"));
    }
}

// Quickview
if(!customElements.get('quick-view')) {
  class quickView extends HTMLElement {
    constructor() {
      super();

      // Variables for quickView class
      // if(this.querySelector('button')){
      this.quickviewBtn = this.querySelector('button');
      // }
      this.productJson = JSON.parse(this.querySelector('script').textContent);
      this.quickViewEle = this.closest('.quick-view__closest').querySelector('#quickViewModal');

      //init js
      this.onClick();
      this.onClose();
    }
    
    // onClick for popup open
    onClick = () => {
      if(this.quickviewBtn){
      this.quickviewBtn.addEventListener('click', () => {
        this.initQuickView();
      })
      
    
      this.quickviewBtn.addEventListener('click', () => {
        this.initQuickView();
      })
      }
    }
    // onClose for popup close
    onClose = () => {
      let quickviewClose = this.closest('.quick-view__closest').querySelector('.quick-view-close');
      let overlayclose = this.closest('.quick-view__closest').querySelector('.overlay-background');
      if (quickviewClose){
        quickviewClose.addEventListener('click', () => {
          this.closeQuickView();
        });
      }
      if(overlayclose){
        overlayclose.addEventListener('click', () => {
          this.closeQuickView();
        });
      }
    }
    initQuickView = () => {
      this.quickViewEle.classList.add('active');
      this.url = `/products/${this.productJson.handle}/?section_id=quick-view`;
      fetch(this.url)
      .then(res => res.text())
      .then(body => {
        let quickView = this.closest('.quick-view__closest').querySelector('#quickView');
        const html = this.quickViewEle;
        html.innerHTML = body;
        quickView.classList.add('active');
        document.body.classList.add('quick-view-popup');
      })
    }
    closeQuickView = () =>{
      let quickView = this.closest('.quick-view__closest').querySelector('#quickView');
      quickView.classList.remove('active');
      document.body.classList.remove('quick-view-popup');
      this.quickViewEle.classList.remove('active');
    }
  }
  customElements.define('quick-view',quickView);
}

// size-chart popup 
if (!customElements.get('size-chart')) {
  class sizeChart extends HTMLElement {
    constructor() {
      super();

      // variables for popup modal
       this.sizeChartBtn = document.querySelector('.size-chart_main .size-chart_btn');
       this.sizeChartClose = document.querySelector('.size-chart_main .size-chart_close');
       this.sizeChartContent = document.querySelector('.size-chart_main .size-chart_content');
       this.closePopup = document.querySelector('.size-chart_main .overlay-background');

      //  init js
      this.popupOpen();
      this.popupClose();
    }
    // Open size chart popup
    popupOpen = () => {
      if (this.sizeChartBtn) {
        this.sizeChartBtn.addEventListener('click', () => {
          this.sizeChartContent.classList.toggle('open-popup');
          document.body.classList.toggle('size-chart-popup');
        });
      }
    }
    // Close size chart popup
    popupClose = () => {
      if (this.sizeChartClose) {
        this.sizeChartClose.addEventListener('click', () => {
          this.sizeChartContent.classList.remove('open-popup');
          document.body.classList.remove('size-chart-popup');
        });
      }
      if (this.closePopup) {
        this.closePopup.addEventListener('click', () => {
          this.sizeChartContent.classList.remove('open-popup');
          document.body.classList.remove('size-chart-popup');
        });
      }
    }
    
  }
  customElements.define('size-chart',sizeChart);
}

// On-scroll animation
theme.onScrollAnimation = () => {
  let animationEle = document.querySelectorAll('[mag-animation]');
  let animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let animationDelay = entry.target.dataset?.magDelay;
        if (animationDelay) {
          animationDelay = parseInt(animationDelay)
          setTimeout(() => {
            entry.target.classList.add('mag-animated');  
          }, animationDelay);
        } else {
          entry.target.classList.add('mag-animated');
        }
      }
    })
  },{threshold: [0.25]});
  animationEle.forEach(ele => {
    animationObserver.observe(ele);
  });
}

// init function on ready
window.addEventListener('DOMContentLoaded', () => {
  theme.onScrollAnimation();
  window.theme.closeFilter();
  window.theme.backtoTop();
  window.theme.infiniteScroll();
   if (Shopify.designMode) {
    const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];
    customizationEvents.forEach(event => {
      document.addEventListener(event, () =>  window.theme.onScrollAnimation());
    })
  }
})

class ProductZoom {
  constructor(options = {}) {
    this.mainContainer = document.querySelector(options.mainImageContainer || '.product-slider');
    this.zoomContainer = document.querySelector(options.zoomContainer || '#custZoomContainer');
    this.zoomLevel = options.zoomLevel || 2;
    this.lensSize = options.lensSize || 100; // Added lens size option
    this.currentImage = null;
    this.initialize();
  }

  initialize() {
    if (!this.mainContainer || !this.zoomContainer) return;
    
    this.mainContainer.style.position = 'relative';
    this.zoomContainer.style.display = 'none';
    this.zoomContainer.style.position = 'absolute';
    this.zoomContainer.style.overflow = 'hidden';
    
    // Add lens element
    this.lens = document.createElement('div');
    this.lens.className = 'zoom-lens';
    this.lens.style.position = 'absolute';
    this.lens.style.width = `${this.lensSize}px`;
    this.lens.style.height = `${this.lensSize}px`;
    this.lens.style.pointerEvents = 'none';
    this.lens.style.display = 'none';
    this.lens.style.zIndex = '2';
    this.mainContainer.appendChild(this.lens);
    
    // Create and store zoom image element
    this.zoomedImage = document.createElement('img');
    this.zoomedImage.style.position = 'absolute';
    this.zoomedImage.style.maxWidth = 'none';
    this.zoomedImage.style.maxHeight = 'none';
    this.zoomContainer.appendChild(this.zoomedImage);
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.mainContainer.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.mainContainer.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.mainContainer.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          this.updateCurrentImage();
        }
      });
    });

    observer.observe(this.mainContainer, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  updateCurrentImage() {
    const visibleImage = this.mainContainer.querySelector('.slick-current img') || 
                        this.mainContainer.querySelector('.swiper-slide-active img') ||
                        this.mainContainer.querySelector('img');
                        
    if (visibleImage && visibleImage.src !== this.currentImage) {
      this.currentImage = visibleImage.src;
      if (this.zoomedImage) {
        this.zoomedImage.src = this.currentImage;
      }
    }
  }

  handleMouseEnter(e) {
    this.updateCurrentImage();
    
    if (!this.currentImage) return;
    
    this.zoomedImage.src = this.currentImage;
    this.zoomContainer.style.display = 'block';
    this.lens.style.display = 'block';
    
    const rect = this.mainContainer.getBoundingClientRect();
    this.zoomContainer.style.width = `${rect.width}px`;
    this.zoomContainer.style.height = `${rect.height}px`;
    
    this.updateZoomPosition(e);
  }

  handleMouseMove(e) {
    if (this.zoomContainer.style.display === 'block') {
      this.updateZoomPosition(e);
    }
  }

  handleMouseLeave() {
    this.zoomContainer.style.display = 'none';
    this.lens.style.display = 'none';
  }

  updateZoomPosition(e) {
    if (!this.zoomedImage) return;

    const rect = this.mainContainer.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Update lens position
    const lensLeft = x - this.lensSize / 2;
    const lensTop = y - this.lensSize / 2;
    
    // Keep lens within bounds
    this.lens.style.left = `${Math.max(0, Math.min(rect.width - this.lensSize, lensLeft))}px`;
    this.lens.style.top = `${Math.max(0, Math.min(rect.height - this.lensSize, lensTop))}px`;

    // Original zoom calculation
    const xRatio = (e.clientX - rect.left) / rect.width;
    const yRatio = (e.clientY - rect.top) / rect.height;

    const zoomWidth = rect.width * this.zoomLevel;
    const zoomHeight = rect.height * this.zoomLevel;

    this.zoomedImage.style.width = `${zoomWidth}px`;
    this.zoomedImage.style.height = `${zoomHeight}px`;
    this.zoomedImage.style.left = `${-xRatio * (zoomWidth - rect.width)}px`;
    this.zoomedImage.style.top = `${-yRatio * (zoomHeight - rect.height)}px`;
  }

  handleVariantChange(event) {
    const variant = event.detail;
    if (variant && variant.featured_image) {
      this.currentImage = variant.featured_image.src;
      if (this.zoomedImage) {
        this.zoomedImage.style.backgroundImage = `url(${this.currentImage})`;
      }
    }
  }

  setZoomLevel(level) {
    this.zoomLevel = level;
  }

  destroy() {
    this.mainContainer.removeEventListener('mouseenter', this.handleMouseEnter);
    this.mainContainer.removeEventListener('mousemove', this.handleMouseMove);
    this.mainContainer.removeEventListener('mouseleave', this.handleMouseLeave);
    document.removeEventListener('variant:change', this.handleVariantChange);
    if (this.lens) {
      this.lens.remove();
    }
  }
}

// Initialize zoom functionality
document.addEventListener('DOMContentLoaded', () => {
  const productZoom = new ProductZoom({
    mainImageContainer: '.product-slider',
    zoomContainer: '#custZoomContainer',
    zoomLevel: 2.5,
    lensSize: 100
  });
});

// Additional event listeners for common slider libraries
document.addEventListener('afterChange', () => {
  const productZoom = new ProductZoom({
    mainImageContainer: '.product-slider',
    zoomContainer: '#custZoomContainer'
  });
});

// For Swiper slider
document.addEventListener('slideChange', () => {
  const productZoom = new ProductZoom({
    mainImageContainer: '.product-slider',
    zoomContainer: '#custZoomContainer'
  });
});


class CartManager {
  constructor() {
    this.eventBindCount = 0;
    this.bindElements();
    this.setupMasterEventListener();
    this.bindElementSpecificEvents();
    this.initializeCart();
    this.setupQuickViewObserver();
    this.setupRelatedProductsObserver();
  }

  setupRelatedProductsObserver() {
    // Code unchanged
    const relatedProductsContainer = document.querySelector('.related-products');
    if (!relatedProductsContainer) return;
  
    this.bindRelatedProductEvents(relatedProductsContainer);
  
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          const addedProductCards = Array.from(mutation.addedNodes)
            .filter(node => node.nodeType === Node.ELEMENT_NODE)
            .some(node => 
              node.querySelector('[data-atc-main]') || 
              node.querySelector('.add-to-cart-btn')
            );
  
          if (addedProductCards) {
            this.bindRelatedProductEvents(relatedProductsContainer);
          }
        }
      });
    });
  
    observer.observe(relatedProductsContainer, {
      childList: true,
      subtree: true
    });
  }
  
  bindRelatedProductEvents(container) {
    // Code unchanged
    const addToCartButtons = container.querySelectorAll('[data-atc-main], .add-to-cart-btn');
    
    addToCartButtons.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });
  }

  setupQuickViewObserver() {
    // Code unchanged
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (
              node.classList?.contains('quick-view-modal') || 
              node.querySelector('.shopify-product-form')
            )) {
              this.bindQuickViewAddToCart(node);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  bindQuickViewAddToCart(container) {
    // Code unchanged
    const quickViewAddToCartBtns = container.querySelectorAll('[data-atc-main], .add-to-cart-btn');
    
    quickViewAddToCartBtns.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });
  }

  bindElements() {
    // Code unchanged
    this.cartDrawer = document.querySelector('#cartDrawer');
    this.cartNotificationProduct = document.querySelector('#cartNotificationProduct');
    this.cartCount = document.querySelector('[data-cart-count]');
    this.subtotalElement = document.querySelector('.cart-subtotal');
    this.cartDrawerWrapper = document.querySelector('.cart-drawer-wrapper');
    this.actionCart = document.querySelector('.action-cart');
    this.cartDrawerIndex = document.querySelector('.cart-drawer-index');
    this.addToCartButtons = document.querySelectorAll('[data-atc-main], .add-to-cart-btn');
  }

  setupMasterEventListener() {
    // Code unchanged
    document.addEventListener('click', (e) => {
      const addToCartButton = e.target.closest('[data-atc-main], .add-to-cart-btn');
      if (addToCartButton) {
        e.preventDefault();
        e.stopPropagation();
        this.handleAddToCart(e);
        return;
      }
      
      const cartIcon = e.target.closest('.action-cart');
      if (cartIcon && this.cartDrawerIndex) {
        e.preventDefault();
        e.stopPropagation();
        this.cartDrawerIndex.classList.toggle('active');
        return;
      }

      const closeDrawer = e.target.closest('#closeDrawer');
      if (closeDrawer) {
        e.preventDefault();
        this.closeCartDrawer();
        return;
      }

      const overlay = e.target.closest('.cart-drawer-overlay');
      if (overlay) {
        e.preventDefault();
        this.closeCartDrawer();
        return;
      }
    });

    document.addEventListener('filter:applied', () => {
      console.log('Filter applied event received');
      this.reinitializeCartEvents();
    });
  }

  bindElementSpecificEvents() {
    this.eventBindCount++;
    console.log(`Element-specific events bound ${this.eventBindCount} times`);
    
    if (this.cartNotificationProduct) {
      const newCartNotificationProduct = this.cartNotificationProduct.cloneNode(true);
      if (this.cartNotificationProduct.parentNode) {
        this.cartNotificationProduct.parentNode.replaceChild(newCartNotificationProduct, this.cartNotificationProduct);
      }
      this.cartNotificationProduct = newCartNotificationProduct;
      
      this.cartNotificationProduct.addEventListener('click', (e) => {
        if (e.target.closest('.quantity-decrease') || e.target.closest('.quantity-increase')) {
          this.handleQuantityUpdate(e);
        } else if (e.target.closest('.cart-item-remove')) {
          this.handleRemoveItem(e);
        }
      });

      this.cartNotificationProduct.addEventListener('input', (e) => {
        if (e.target.classList.contains('quantity-input')) {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
            e.target.dataset.lastValue = e.target.value;
          }, 500);
        }
      });

      this.cartNotificationProduct.addEventListener('blur', (e) => {
        if (e.target.classList.contains('quantity-input')) {
          const lastValue = e.target.dataset.lastValue;
          const currentValue = e.target.value;
          
          if (lastValue !== currentValue) {
            this.handleQuantityUpdate(e);
          }
        }
      }, true);
    }
  }

  openCartDrawer() {
    // Code unchanged
    if (this.cartDrawer) {
      this.cartDrawer.classList.add('active');
    }
    if (this.cartDrawerIndex) {
      this.cartDrawerIndex.classList.add('active');
    }
  }

  closeCartDrawer() {
    // Code unchanged
    if (this.cartDrawer) {
      this.cartDrawer.classList.remove('active');
    }
    if (this.cartDrawerIndex) {
      this.cartDrawerIndex.classList.remove('active');
    }
  }

  async reinitializeCartEvents() {
    // Code unchanged
    console.log('Reinitializing cart events');
    
    this.bindElements();
    
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    this.updateCartUI(cart);
    
    await this.updateCartDrawerContent(cart);
    
    this.bindElementSpecificEvents();
    
    console.log('Cart events reinitialized successfully');
  }

  async initializeCart() {
    // Code unchanged
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      await this.updateCartDrawerContent(cart);
      this.updateCartUI(cart);
    } catch (error) {
      console.error('Error initializing cart:', error);
    }
  }

  createLoader() {
    // Code unchanged
    const loader = document.createElement('div');
    loader.className = 'cart-loader';
    loader.innerHTML = `
      <div class="cart-loader__spinner">
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
    return loader;
  }

  async handleAddToCart(e) {
    // Code unchanged
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.target.closest('[data-atc-main], .add-to-cart-btn');
    if (!button) return;

    console.log("Add to cart clicked", button);
    const form = button.closest('form');
    if (!form) {
      console.error("No form found for add to cart button");
      return;
    }

    const errorContainer = form.querySelector('.error');
    const errorText = errorContainer?.querySelector('[data-error-text]');
    
    const originalButtonText = button.innerHTML;
    button.setAttribute('disabled', true);
    
    const loader = this.createLoader();
    button.innerHTML = '';
    button.appendChild(loader);
    button.classList.add('btn--loading');
    
    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
            
      const initialCartResponse = await fetch('/cart.js');
      const initialCart = await initialCartResponse.json();
      const initialItemCount = initialCart.item_count;
      
      const mainResponse = await fetch(theme.routes.cart_add_url, {
        method: 'POST', 
        headers: {
          "Accept": "application/javascript",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      });
      
      const mainRes = await mainResponse.json();
      if (mainRes.status === 422) {
        mainRes.description = "You can't add more items in cart";
        this.showError(errorContainer, errorText, mainRes.description, button);
        return;
      }
      
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
            
      await this.updateCartDrawerContent(cartData);
      this.updateCartUI(cartData);
      
      if (cartData.item_count > initialItemCount) {
        this.openCartDrawer();
        this.cartDrawer.querySelector('button')?.focus();
      }
       
      if (typeof theme.onScrollAnimation === 'function') {
        theme.onScrollAnimation();
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showError(errorContainer, errorText, 'Error adding products to cart', button);
    } finally {
      button.innerHTML = originalButtonText;
      button.removeAttribute('disabled');
      button.classList.remove('btn--loading');
    }
  }

  async handleQuantityUpdate(e) {
    e.preventDefault();
    const cartItem = e.target.closest('.cart-item');
    if (!cartItem) return;
  
    const lineKey = cartItem.dataset.lineKey;
    const quantityInput = cartItem.querySelector('.quantity-input');
    const currentQuantity = parseInt(quantityInput.value);
    const errorContainer = cartItem.querySelector('.cart__error .error__message');
    let newQuantity = currentQuantity;
    
    if (e.target.closest('.quantity-decrease')) {
      if (currentQuantity <= 1) {
        return this.handleRemoveItem(e);
      }
      newQuantity = currentQuantity - 1;
      if (newQuantity === currentQuantity) return;
    } else if (e.target.closest('.quantity-increase')) {
      newQuantity = currentQuantity + 1;
      if (newQuantity === currentQuantity) return;
    } else if (e.type === 'input' || e.type === 'change' || e.type === 'blur') {
      const inputValue = parseInt(e.target.value);
      if (!isNaN(inputValue)) {
        if (inputValue <= 0) {
          return this.handleRemoveItem(e);
        }
        newQuantity = inputValue;
      } else {
        quantityInput.value = currentQuantity;
        return;
      }
    }
    
    try {
      // Show loading state
      cartItem.classList.add('updating');
      e.target.closest('button').setAttribute('disabled',true)
      
      // Store the original input value to revert back if needed
      const originalQuantity = quantityInput.value;
      
      // Update quantity visually immediately (for better UX)
      quantityInput.value = newQuantity;
      
      // Now send the update to the server
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: newQuantity
        })
      });
  
      const cart = await response.json();
      if(!cart) return;
      
      const updatedItem = cart.items.find(item => item.key === lineKey);
      
      // Update quantity input and price with accurate data from the server
      if (updatedItem) {
        // Check if the server returned a different quantity than requested
        if (updatedItem.quantity !== newQuantity) {
          // Revert back to the quantity that's actually available
          quantityInput.value = updatedItem.quantity;
          quantityInput.dataset.lastValue = updatedItem.quantity.toString();
          
          // Update price based on what's actually in the cart
          this.updateItemPrice(cartItem, updatedItem);
          
          // Show error message
          this.showError(cartItem, errorContainer, `Only ${updatedItem.quantity} item(s) available`);
        } else {
          // Server accepted our requested quantity, update as normal
          quantityInput.value = updatedItem.quantity;
          quantityInput.dataset.lastValue = updatedItem.quantity.toString();
          this.updateItemPrice(cartItem, updatedItem);
        }
      } else if (newQuantity <= 0) {
        cartItem.style.opacity = '0';
        cartItem.style.height = '0';
        setTimeout(() => cartItem.remove(), 300);
      }
  
      // Update cart drawer and UI with server data
      this.updateCartUI(cart);
  
    } catch (error) {
      console.error('Error updating quantity:', error);
      // Revert to the previous valid quantity on error
      quantityInput.value = currentQuantity;
      quantityInput.dataset.lastValue = currentQuantity.toString();
      
      if (errorContainer) {
        errorContainer.textContent = "You can't add more items in cart";
        errorContainer.style.display = 'block';
        
        setTimeout(() => {
          errorContainer.style.display = 'none';
          errorContainer.textContent = '';
        }, 3000);
      }
    } finally {
      e.target.closest('button').removeAttribute('disabled')
      cartItem.classList.remove('updating');
    }
  }
  // Extract price per item from the cart item
  extractPricePerItem(cartItem) {
    // Look for any hidden price-per-item data
    if (cartItem.dataset.price) {
      return parseInt(cartItem.dataset.price);
    }
    
    // Look for quantity input and current price display
    const quantityInput = cartItem.querySelector('.quantity-input');
    const priceElement = cartItem.querySelector('.cart-item-price');
    
    if (quantityInput && priceElement) {
      const currentQuantity = parseInt(quantityInput.value) || 1;
      // Extract the price from the price element (removing currency symbols, etc.)
      const priceText = priceElement.textContent.trim();
      const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, '')) * 100; // Convert to cents
      
      return numericPrice / currentQuantity;
    }
    
    return null;
  }

  // Update item price display with formatted price
  updateItemPrice(cartItem, cartItemData) {
    const priceElement = cartItem.querySelector('.item-price .price');
    if (priceElement && cartItemData) {
      // Calculate total price (line price)
      const linePrice = cartItemData.line_price || cartItemData.price * cartItemData.quantity;
      priceElement.innerHTML = window.theme.formatMoney(linePrice, window.theme.money_format);
      
      // Store the price per item for future calculations
      cartItem.dataset.price = cartItemData.price;
    }
  }

  async handleRemoveItem(e) {
    // Code unchanged
    e.preventDefault();
    const cartItem = e.target.closest('.cart-item');
    if (!cartItem) return;

    const lineKey = cartItem.dataset.lineKey;

    try {
      cartItem.classList.add('updating');

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });

      const cart = await response.json();

      // Animate removal
      cartItem.style.opacity = '0';
      cartItem.style.height = '0';
      cartItem.style.transition = 'all 0.3s ease-out';

      setTimeout(async () => {
        cartItem.remove();
        await this.updateCartDrawerContent(cart);
        this.updateCartUI(cart);
      }, 300);

    } catch (error) {
      console.error('Error removing item:', error);
      this.showError(cartItem, null, 'Unable to remove item');
      cartItem.classList.remove('updating');
    }
  }

  async updateCartDrawerContent(cart) {
    try {
      const response = await fetch('/cart?section_id=cart-drawer-item');
      const html = await response.text();
  
      if (this.cartNotificationProduct) {
        this.cartNotificationProduct.innerHTML = '';
      
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(html, 'text/html');
        const lineItems = parsedHtml.querySelectorAll('[data-line-key]');
    
        lineItems.forEach(item => {
          const lineKey = item.dataset.lineKey;
          const cartItem = cart.items.find(cartItem => cartItem.key === lineKey);
  
          if (cartItem) {
            // Update quantity
            const quantityInput = item.querySelector('.quantity-input');
            if (quantityInput) {
              quantityInput.value = cartItem.quantity;
            }
            
            // Update price
            const priceElement = item.querySelector('.item-price .price');
            if (priceElement) {
              const linePrice = cartItem.line_price || cartItem.price * cartItem.quantity;
              priceElement.innerHTML = window.theme.formatMoney(linePrice, window.theme.money_format);
              
              // Store price per item for quick calculations
              item.dataset.price = cartItem.price;
            }
          }
    
          // Append the updated item to the cart drawer
          this.cartNotificationProduct.appendChild(item.cloneNode(true));
        });
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }

  updateCartUI(cart) {
    // Code for updating cart count and subtotal
    if (this.cartCount) {
      const count = cart.item_count || 0;
      const cartCountEl = document.querySelector('[data-cart-count]');
      if (cartCountEl) {
        cartCountEl.textContent = count;
      }
      this.cartCount.innerHTML = count;
      this.cartCount.style.display = count > 0 ? '' : 'none';
    }
    
    if (this.subtotalElement) {
      this.subtotalElement.innerHTML = `<strong>Subtotal:</strong> ${window.theme.formatMoney(cart.total_price, window.theme.money_format)}`;
    }
    
    if (this.cartDrawerWrapper) {
      if (cart.item_count === 0) {
        this.cartDrawerWrapper.classList.add('is-empty');
        if (this.cartNotificationProduct) {
          this.cartNotificationProduct.innerHTML = '<p>Your cart is empty</p>';
        }
      } else {
        this.cartDrawerWrapper.classList.remove('is-empty');
      }
    }
    
    // Update individual item prices
    if (this.cartNotificationProduct && cart.items) {
      const cartItems = this.cartNotificationProduct.querySelectorAll('[data-line-key]');
      cartItems.forEach(item => {
        const lineKey = item.dataset.lineKey;
        const cartItem = cart.items.find(item => item.key === lineKey);
        
        if (cartItem) {
          // Update price
          const priceElement = item.querySelector('.cart-item-price');
          if (priceElement) {
            const linePrice = cartItem.line_price || cartItem.price * cartItem.quantity;
            priceElement.innerHTML = window.theme.formatMoney(linePrice, window.theme.money_format);
            
            // Store price per item for future calculations
            item.dataset.price = cartItem.price;
          }
        }
      });
    }
  }

  showError(container, textElement, message, button = null) {
    // Code unchanged
    let errorContainer = container;
    let errorText = textElement;

    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = 'error';
      container.appendChild(errorContainer);
    }
    
    if (!errorText) {
      errorText = errorContainer.querySelector('.error-add-to-cart');
      if (!errorText) {
        errorText = document.createElement('div');
        errorText.className = 'error-add-to-cart';
        errorContainer.appendChild(errorText);
      }
    }
    
    errorText.textContent = message;
    
    if (button) {
      button.classList.remove('btn--loading');
    }
  
    errorContainer.style.display = 'block';

    setTimeout(() => {
      errorContainer.style.display = 'none';
    }, 3000);
  }
}

// Initialize cart manager
document.addEventListener('DOMContentLoaded', () => {
  window.cartManager = new CartManager();
});

// Custom event listener for quick view loaded
document.addEventListener('quickview:loaded', (e) => {
  if (e.detail && e.detail.container) {
    const container = typeof e.detail.container === 'string' 
      ? document.querySelector(e.detail.container) 
      : e.detail.container;
    
    if (container && window.cartManager) {
      window.cartManager.bindQuickViewAddToCart(container);
    }
  }
});

document.addEventListener('related-products:loaded', () => {
  if (window.cartManager) {
    window.cartManager.setupRelatedProductsObserver();
  }
});